import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from './auth-service.service';

@Injectable({
  providedIn: 'root'
})
export class VerifiedAccountGuardService  implements CanActivate {

  constructor(private auth: AuthService, private router: Router) { }

  canActivate() {
    console.log('VerifiedAccountGuardService  emailVerified');
    console.log(this.auth.userDetails.emailVerified);
  return this.auth.userDetails.emailVerified ? true : this.router.navigate(['auth/verify-account']);
  }
}